import GenericComponent from '../../GenericComponent';
import {toggleClass} from '../../helpers';

export default class threads_edit extends GenericComponent {
    constructor(uri, app, className, data) {
        super(uri, app, (className || 'threads_edit'), data);
        this.template = 'threads_edit';
    }

    edit(status = true) {
        this.parent && this.parent.edit(status);
        toggleClass(document.body, 'modal-open', status);
    }
}
